import {onBeforeUnmount, onMounted} from "vue";

export const useAnimateInTrigger = (ref, setter) => {
  const intersectionObserver = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      setter("animate-in-vars");
    }
  }, {
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
  });

  onMounted(() => ref?.value && intersectionObserver.observe(ref.value));
  onBeforeUnmount(() => ref?.value && intersectionObserver.unobserve(ref.value));
};
